import React from 'react'
import cardOne from './Images/rowTwo/cardFour.jpg'
import cardTwo from './Images/rowTwo/cardFive.jpg'
import cardThree from './Images/rowTwo/cardSix.jpg'
import cardFour from './Images/rowOne/cardOne.jpg'
import cardFive from './Images/rowOne/cardFour.jpg'
import cardSix from './Images/rowOne/cardFive.jpg'
import { useContext } from 'react'
import NoteContext from '../context/notes/noteContext'
export default function OurServices() {

    const context = useContext(NoteContext)
    const {backgroundColor,setBackgroundColor} = context

    setBackgroundColor('black')
    return (
        <div className='pt-5' style={{}}>


            <div >

                <div className="container">
                    <div className="row">
                        <div className="col-12 col-md-4">
                            <div style={{ borderColor: "white", borderRadius: '0px' }} class="card">
                                <img src={cardOne} class="card-img-top" alt="..." />
                                <div style={{ backgroundColor: 'white' }} class="card-body">
                                    <h5 class="card-title">House Renovation</h5>
                                    <p class="card-text">Constructor explains how you can enjoy high end flooring trends like textured wood and realistic stones with new laminate flooring.</p>
                                    <a style={{ color: '#A10302' }} href="#" >READ MORE</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div style={{ borderColor: "white", borderRadius: '0px' }} class="card">
                                <img src={cardTwo} class="card-img-top" alt="..." />
                                <div style={{ backgroundColor: 'white' }} class="card-body">
                                    <h5 class="card-title">The Effective Teamwork</h5>
                                    <p class="card-text">As the general contractor, we first create the highest level of trust and integrity with our clients. We value our role in the success of your project.</p>
                                    <a style={{ color: '#A10302' }} href="#" >READ MORE</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div style={{ borderColor: "white", borderRadius: '0px' }} class="card">
                                <img src={cardThree} class="card-img-top" alt="..." />
                                <div style={{ backgroundColor: 'white' }} class="card-body">
                                    <h5 class="card-title">The Green Building</h5>
                                    <p class="card-text">Green construction refers to a structure and using process that is environmentally responsible and resource-efficient throughout a building's life cycle.</p>
                                    <a style={{ color: '#A10302' }} href="#" >READ MORE</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div style={{ borderColor: "white", borderRadius: '0px' }} class="card">
                                <img src={cardFour} class="card-img-top" alt="..." />
                                <div style={{ backgroundColor: 'white' }} class="card-body">
                                    <h5 class="card-title">Construction Consultant</h5>
                                    <p class="card-text">As the general contractor, we first create the highest level of trust and integrity with our clients. We value our role in the success of your project.</p>
                                    <a style={{ color: '#A10302' }} href="#" >READ MORE</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div style={{ borderColor: "white", borderRadius: '0px' }} class="card">
                                <img src={cardFive} class="card-img-top" alt="..." />
                                <div style={{ backgroundColor: 'white' }} class="card-body">
                                    <h5 class="card-title">General Contracting</h5>
                                    <p class="card-text">As the general contractor, we first create the highest level of trust and integrity with our clients. We value our role in the success of your project.</p>
                                    <a style={{ color: '#A10302' }} href="#" >READ MORE</a>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div style={{ borderColor: "white", borderRadius: '0px' }} class="card">
                                <img src={cardSix} class="card-img-top" alt="..." />
                                <div style={{ backgroundColor: 'white' }} class="card-body">
                                    <h5 class="card-title">Metal Roofing</h5>
                                    <p class="card-text">Homeowners can have confidence in their choice of a metal roofing contractor knowing they have met certain requirements in their services.</p>
                                    <a style={{ color: '#A10302' }} href="#" >READ MORE</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/services copy 6.jsx